import {
  AppLayout,
  Box,
  Button,
  Container,
  ContentLayout,
  SpaceBetween,
} from "@amzn/awsui-components-console";
import { signInWithRedirect } from "aws-amplify/auth";
import React, { useState } from "react";

import mambaLogo from "@/assets/logo/mamba-logo.png";
import nbaLogo from "@/assets/logo/pvls-nba-logo.png";

const LoginPage: React.FC = () => {
  const [loading, setLoading] = useState(false);

  const handleOktaSignIn = async () => {
    setLoading(true);
    try {
      await signInWithRedirect();
    } catch (error) {
      console.error("Error signing in with Okta:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AppLayout
      navigationHide
      toolsHide
      contentType="default"
      content={
        <ContentLayout
          header={
            <Box padding={{ top: "l" }}>
              <Box textAlign="center">
                <img
                  src={nbaLogo}
                  alt="Prime Video and NBA"
                  style={{ maxWidth: "250px", height: "auto" }}
                />
              </Box>
              <Box textAlign="center" color="text-status-inactive">
                &copy; All Rights Reserved
              </Box>
            </Box>
          }
        >
          <Box padding={{ vertical: "xxxl" }}>
            <Container>
              <Box padding="s">
                <SpaceBetween size="m">
                  <SpaceBetween direction="horizontal" size="m">
                    <Box>
                      <img
                        src={mambaLogo}
                        alt="Prime Video and NBA"
                        style={{ height: "100px", width: "auto" }}
                      />
                    </Box>
                    <SpaceBetween size="xs">
                      <Box
                        fontSize="display-l"
                        fontWeight="bold"
                        variant="h1"
                        padding="n"
                      >
                        Welcome to MAMBA!
                      </Box>
                      <Box fontSize="display-l" fontWeight="light">
                        Media Asset Management Broadcast Assistant
                      </Box>
                    </SpaceBetween>
                  </SpaceBetween>
                  <Box variant="p" color="text-body-secondary">
                    For Prime Video Live Sports, this is a Generative AI
                    Semantic Search for NBA statistics. Ask questions and
                    generate insights that can drive stories for NBA teams and
                    players.
                  </Box>
                  <Button
                    variant="primary"
                    onClick={handleOktaSignIn}
                    disabled={loading}
                    loading={loading}
                  >
                    Sign in with Okta
                  </Button>
                  {/* Terms of service, at the foot of the page content and below
                      the sign-in control. Plain text only: no role, no tabIndex
                      and no anchor, so it never announces itself to assistive
                      technology as something that can be activated. The wrapping
                      div carries the test id because Box does not forward
                      data-* attributes. Copy is placeholder text. */}
                  <div data-testid="terms-of-service">
                    <SpaceBetween size="xxs">
                      <Box
                        fontSize="body-s"
                        fontWeight="bold"
                        color="text-body-secondary"
                      >
                        Terms of Use — Mamba
                      </Box>
                      <Box
                        variant="p"
                        fontSize="body-s"
                        color="text-body-secondary"
                      >  
You are about to log into the Mamba application, which is a multi-sport LLM used by Prime Video Live Sports production teams for researching questions across all Amazon sports properties and presents links to available media assets matching your query.

Mamba is an AI-assisted tool. Its responses are generated by a large language model and may be incomplete, outdated, or incorrect. All outputs should be treated as a starting point for research, not a final source of truth. You are responsible for validating any information before using it in production content, broadcasts, or decisions.

Guidelines for use:
Verify before publishing. Confirm statistics, dates, records, and factual claims against authoritative sources before they appear on-air or in any deliverable.

Do not input confidential or sensitive data. Avoid entering personal information, unreleased contractual details, or non-public business information into prompts.

Outputs are not legal or rights advice. For questions involving media rights, licensing, or clearances, consult the appropriate legal or rights management team.

Report inaccuracies. If Mamba returns content that is factually wrong or otherwise problematic, report it through the feedback mechanism so the team can improve the system.

Use of this tool constitutes agreement to Amazon's Acceptable Use Policy for generative AI applications. Access is granted for business purposes only.
                      </Box>
                    </SpaceBetween>
                  </div>
                </SpaceBetween>
              </Box>
            </Container>
          </Box>
        </ContentLayout>
      }
    />
  );
};

export default LoginPage;
